import { useContext } from 'react';
import { WhoamiContext } from './Whoami';

export const useWhoami = () => {
  return useContext(WhoamiContext);
};
